export const feedbackOptions = {
  Tutor: [
    "feedback.tutor.punctuality",
    "feedback.tutor.engagement",
    "feedback.tutor.feedback",
    "feedback.tutor.clarity",
    "feedback.tutor.technical",
  ],
  "Topic and organization": {
    speaking: [
      "feedback.topic.speaking.relevance",
      "feedback.topic.speaking.fluency",
      "feedback.topic.speaking.size",
      "feedback.topic.speaking.opportunity",
    ],
    correction: [
      "feedback.topic.correction.corrections",
      "feedback.topic.correction.time",
      "feedback.topic.correction.feedbacks",
      "feedback.topic.correction.booking",
    ],
    ielts: [
      "feedback.topic.ielts.resources",
      "feedback.topic.ielts.personalization",
      "feedback.topic.ielts.size",
      "feedback.topic.ielts.duration",
    ],
    mocktest: [
      "feedback.topic.mocktest.questions",
      "feedback.topic.mocktest.feedbacks",
      "feedback.topic.mocktest.booking",
      "feedback.topic.mocktest.realism",
      "feedback.topic.mocktest.strategy",
    ],
    grammar: [
      "feedback.topic.grammar.resources",
      "feedback.topic.grammar.size",
      "feedback.topic.grammar.relevance",
    ],
  },
};